import React, { Component } from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import FooterPage from "../partials/footerPage";
import Cookies from "universal-cookie";
const cookies = new Cookies();


class Skolas14 extends Component {
  render() {

    if (!this.props.data.page) {
      return <p>...</p>;
    }

    //console.log(CarouselIndicators);
    return (
      <React.Fragment>
        <div>
          <div id="singleFaq"
            className="singlePage"
            data-headertitle={
              cookies.get("lang") === "LV" ? this.props.data.page.title : cookies.get("lang") === "EN" ? this.props.data.page.translation.title : null
            }>
            <div className="container single-content-text">
              <h2>{
                cookies.get("lang") === "LV" ? this.props.data.page.title : cookies.get("lang") === "EN" ? this.props.data.page.translation.title : null
              }</h2>
              {cookies.get("lang") === "LV" ?
                <p dangerouslySetInnerHTML={{ __html: this.props.data.page.content }} /> :
                <p dangerouslySetInnerHTML={{ __html: this.props.data.page.translation.content }} />
              }
            </div>
          </div>
          <FooterPage />
        </div>
      </React.Fragment>
    );
  }

}

const GetFAQBySlug = gql`
  query skolas14 {
    page(id: "cG9zdDoyMDgz") {
      translation(language: EN) {
        title(format: RENDERED)
        content(format: RENDERED)
      }
      title(format: RENDERED)
      content(format: RENDERED)
    }
  }
`;

export default graphql(GetFAQBySlug)(Skolas14);
